import { useEffect, useState, useContext, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useReactToPrint } from 'react-to-print';

import CustomFilters from '../../../organisms/screener/custom-filters';
import ResultsTable from '../../../organisms/screener/results-table';
import PageSideRail from '../../../molecules/profile/page-side-rail';
import PresetCategories from '../../../organisms/screener/preset-categories';
import PrintDisclosures from '../../../molecules/screener/print-disclosures';
import Header from '../../../organisms/screener/header';
import Footer from '../../../organisms/screener/footer';
import Spinner from '../../../atoms/spinner';

import adobeAnalytics from '../../../../utils/adobe-analytics';
import { CHANNELS, DEFAULT_VIEWS } from '../../../../shared/screener-constants';
import ScreenerAppContext from '../../../../stores/screener/screener-app-context';
import { connect } from 'react-redux';
import {
  updateDynamicMicrosite,
  updateParticipantHolding
} from '../../../../stores/screener/actions/filter-actions';
import Icon from '../../../atoms/icon';
import { className } from '../../../../utils/GlobalCssProxy';

export const ScreenerTemplate = ({ getDynamicMicrosite, getParticipantHolding, resultData }) => {
  const { Plans, channel, yyy, defaultView, prodTestVariable } = useContext(ScreenerAppContext);
  const [slideUp, setSlideUp] = useState(false);
  const [performanceQuarterly, setPerformanceQuarterly] = useState(true);

  // We store the resolve Promise being used in `onBeforeGetContent` here
  const printRef = useRef(null);

  const collapsePresetCategory = () => {
    window.scrollTo({ top: 0 });
    setSlideUp(true);
  };

  const expandPresetCategory = () => {
    setSlideUp(false);
  };

  const viewResult = () => {
    if (!slideUp) {
      setSlideUp(true);
    }
    const resultCount = document.getElementById('result-count');
    resultCount.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (defaultView !== DEFAULT_VIEWS.NONE) {
      collapsePresetCategory();
    }
    if (channel === CHANNELS.DYNAMICMICROSITES) {
      collapsePresetCategory();
      getDynamicMicrosite(Plans, channel, yyy);
    }
    if (channel === CHANNELS.MYTIAA) {
      collapsePresetCategory();
      getParticipantHolding(channel, yyy, prodTestVariable);
    }
  }, [channel]);

  // Handles updating Adobe Analytics for the ScreenerApp when hosted via a TIAA integrated environment.
  useEffect(() => {
    adobeAnalytics.setScreenerPageTags({ pageName: 'PG:InvestPerform_ScreenerPage' });
    if (jQuery) {
      jQuery(document).trigger('analyticsload.tiaacref', '#com_tiaa_screener');
    }
  }); // Apply to each render

  return (
    <>
      {
        <Icon.TIAALogo
          customClassOnly={true}
          {...className(
            'd-none',
            'd-print-inline-block',
            'print-tiaa-logo',
            'svg-icon',
            'position-relative',
            'print-only'
          )}
        />
      }
      <div {...className('print-black-white', 'overflow-hidden')}>
        <Spinner />
        <Header collapsePresetCategory={collapsePresetCategory} />
        <PresetCategories
          slideUp={slideUp}
          viewResult={viewResult}
          collapsePresetCategory={collapsePresetCategory}
        />
        <CustomFilters viewResult={viewResult} expandPresetCategory={expandPresetCategory} />
        <div ref={printRef}>
          <ResultsTable
            performanceQuarterly={performanceQuarterly}
            setPerformanceQuarterly={setPerformanceQuarterly}
            slideUp={slideUp}
            viewResult={viewResult}
          />
          <Footer />
          <PrintDisclosures />
        </div>
        <PageSideRail appContext="screener" />
        <div
          {...className(
            'screener-adMaster-number-container',
            'print-only',
            'print-screener-disclosure-margin'
          )}
        >
          <div {...className('screener-adMaster-number')}>4347032</div>
        </div>
      </div>
    </>
  );
};

ScreenerTemplate.propTypes = {
  getDynamicMicrosite: PropTypes.func,
  getParticipantHolding: PropTypes.func,
  resultData: PropTypes.object
};

const mapStateToProps = state => {
  return {
    resultData: state.resultData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDynamicMicrosite: (Plans, channel, yyy) =>
      dispatch(updateDynamicMicrosite(Plans, channel, yyy)),
    getParticipantHolding: (channel, yyy) => dispatch(updateParticipantHolding(channel, yyy))
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  ScreenerTemplate
);
